enum Width {
    FIT_CONTENT = 'fit-content',
    FULL_WIDTH = '100%'
}

export default Width;